"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CreateMultipartUploadInput_1 = require("./CreateMultipartUploadInput");
var CreateMultipartUploadOutput_1 = require("./CreateMultipartUploadOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.CreateMultipartUpload = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "CreateMultipartUpload",
    http: {
        method: "POST",
        requestUri: "/{Bucket}/{Key+}?uploads"
    },
    input: {
        shape: CreateMultipartUploadInput_1.CreateMultipartUploadInput
    },
    output: {
        shape: CreateMultipartUploadOutput_1.CreateMultipartUploadOutput
    },
    errors: []
};
//# sourceMappingURL=CreateMultipartUpload.js.map